import React, { useEffect } from 'react';

import style from './tooltip.module.scss';

const Tooltip = ({ children, coords, updateTooltipCoords }) => {
  const updateCoords = updateTooltipCoords;

  useEffect(() => {
    window.addEventListener('resize', updateCoords);
    return () => window.removeEventListener('resize', updateCoords);
  }, [updateCoords]);

  return (
    <div className={style.tooltip} style={{ ...coords }}>
      <div className={style.content}>
        <div className={style.arrow} />
        <div className={style.inner} role="tooltip">
          <div>
            <div className={style.contentInner}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Tooltip };
